import { Language } from '@configs/language';

const BASE_LANGUAGE_LABELS = {
  pyfwdRemainingDays: 'You have {{days}} days left',
  pyfwdAmountToSend: 'Amount to send',
  pyfwdAmountToReceive: 'Amount to receive',
  pyfwdEnoughBalance: 'You have enough balance to complete this forward',
  pyfwdNotEnoughBalance:
    'Sorry, you do not have enough balance to complete this deposit',
  pyfwdConfirm: 'Complete deposit',
  pyfwdRecipient: 'Recipient',
  pyfwdMovementType: 'Movement type',
  pyfwdExecutionDate: 'Execution date',
  pyfwdDueDate: 'Due date',
  pyfwdexchangeRate: 'Exchange Rate',
  pyfwdPaymentMethod: 'Forward between my currencies',
  pyfwdConfirmTitle: 'Are you sure you want to complete this forward?',
  pyfwdConfirmButton: 'Confirm',
  pyfwdCancelButton: 'Cancel',
  pyfwdWaitingExecutionDate: 'Waiting for execution date',
};

type LabelsLanguage = keyof typeof BASE_LANGUAGE_LABELS;

const PAY_FORWARDS_LANGUAGE_LABELS: Record<
  Language,
  Record<LabelsLanguage, string>
> = {
  EN: BASE_LANGUAGE_LABELS,
  ES: {
    pyfwdRemainingDays: 'Te quedan {{days}} días',
    pyfwdAmountToSend: 'Monto a enviar',
    pyfwdAmountToReceive: 'Monto a recibir',
    pyfwdEnoughBalance: 'Tienes suficiente balance para completar este forward',
    pyfwdNotEnoughBalance:
      'Lo sentimos no cuentas con suficiente balance para completar este depósito',
    pyfwdConfirm: 'Completar depósito',
    pyfwdRecipient: 'Destinatario',
    pyfwdMovementType: 'Tipo de movimiento',
    pyfwdExecutionDate: 'Fecha de ejecución',
    pyfwdDueDate: 'Fecha de vencimiento',
    pyfwdexchangeRate: 'Tipo de cambio',
    pyfwdPaymentMethod: 'Forward entre mis monedas',
    pyfwdConfirmTitle: '¿Estas seguro de completar este forward?',
    pyfwdConfirmButton: 'Confirmar',
    pyfwdCancelButton: 'Cancelar',
    pyfwdWaitingExecutionDate: 'Esperando fecha de ejecución',
  },
};

export default PAY_FORWARDS_LANGUAGE_LABELS;
